import { Component, Input, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { PlatformService } from '@panamax/app-state';
import { ListState } from '@usf/ngrx-list';
import { Router } from '@angular/router';
import { PATHS } from 'src/app/shared/constants/paths';
import { FoodCostCalculatorService } from '../../services/food-cost-calculator.service';
import { FoodCostReportState } from '@usf/ngrx-inventory';

@Component({
  selector: 'app-food-cost-report-delete-modal',
  templateUrl: './food-cost-report-delete-modal.component.html',
  styleUrls: ['./food-cost-report-delete-modal.component.scss'],
})
export class FoodCostReportDeleteModalComponent {
  constructor(
    readonly platformService: PlatformService,
    readonly foodCostCalculatorService: FoodCostCalculatorService,
  ) {}

  @Input() foodCostReport: FoodCostReportState;
  @Input() isOpen: boolean;

  onDeleteFoodCostReport() {
    this.foodCostCalculatorService.deleteFoodCostReport(this.foodCostReport);
    this.foodCostCalculatorService.showHideDeleteFoodCostReportModal(false);
  }

  dismissModal() {
    this.foodCostCalculatorService.showHideDeleteFoodCostReportModal(false);
  }

  onDidDismiss() {
    this.dismissModal();
  }
}
